import { AvatarModel } from '../models/avatar/avatar.model';
import { AvatarStylingModel } from '../models/avatar/avatar-styling.model';

export const /** @type {?} */ AvatarTemplates = {
  defaultTemplate: {
    property: new AvatarModel({
      display: true,
      disable: false,
      type: 'image',
      name: '',
      url: '',
      text: '',
      iconName: '',
      charsNumber: 2,
      color: '',
      size: '70px',
      width: '70px',
      height: '70px',
      fontSize: '30px',
      border: '',
      borderRadius: '',
      background: '',
      backgroundImage: '',
      shadow: '',
      facebookId: '',
      googleId: '',
      twitterId: '',
      vkontakteId: '',
      skypeId: '',
      gravatarId: '',
      githubId: '',
    }),
    style: new AvatarStylingModel({
      container: { class: '', dynamicClass: '' },
    })
  }
}
